module.exports = __webpack_public_path__ + "static/media/squarespace.659e7aa2.svg";